import Button from "react-bootstrap/Button";
import './index.css'

interface ButtonComponentProps {
    titel?: any;
    isDisabled?: boolean;
    type?: any;
    onClick?: any;
    icon?: any;
    fullWidth?: boolean;
}

const ButtonComponent: React.FC<ButtonComponentProps> = ({ titel, isDisabled, type, onClick, icon, fullWidth }) => {
    return (<>
        <Button className={`buttonColor mx-2 px-4 ${fullWidth ? 'w-100' : ''}`} disabled={isDisabled} type={type} onClick={onClick}>
            <div className="button-container-styles">
                {icon} &nbsp;
                {titel}
            </div>
        </Button>
    </>)
}

export default ButtonComponent;